<template>
   <div class="mid_scroll_content">
      <section class="max-1440 depoist_fund cap_account_logininfo pb-4">
         <div class="row justify-space-between">
            <div class="col"><strong>IP ADDRESS</strong><span>123.123.123.123</span></div>
            <div class="col"><strong>ISP</strong><span>-</span></div>
            <div class="col"><strong>ISP CODE</strong><span>-</span></div>
            <div class="col"><strong>BROWSER</strong><span>Google Chrome</span></div>
         </div>
      </section>
      <section class="max-1440 web_session">
         <div class="section_title">
            <h5>WEB SESSION</h5>
         </div>
         <div class="row justify-content-center">
            <div class="col-12">
               <div class="dataTable table-responsive">
                  <table id="dtBasicExample-4" width="100%" class="table table-striped table-bordered">
                     <thead class="thead-white">
                        <tr>
                           <th scope="col">SIGNED IN</th>
                           <th scope="col">Broswer</th>
                           <th scope="col">IP ADDRESS</th>
                           <th scope="col">LOCATION</th>
                           <th scope="col">ACTION</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </section>
      <section class="max-1440 web_session">
         <div class="section_title">
            <h5>Confirmed Devices</h5>
         </div>
         <div class="row justify-content-center">
            <div class="col-12">
               <div class="dataTable table-responsive">
                  <table id="dtBasicExample" width="100%" class="table table-striped table-bordered">
                     <thead class="thead-white">
                        <tr>
                           <th scope="col">SIGNED IN</th>
                           <th scope="col">Broswer</th>
                           <th scope="col">IP ADDRESS</th>
                           <th scope="col">LOCATION</th>
                           <th scope="col">ACTION</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                        <tr>
                           <td>10:12:13 08.08.2019</td>
                           <td>Google Chrome</td>
                           <td>123.123.123.112</td>
                           <td>Mohali, India</td>
                           <td><a href="#" class="t_ic"><i data-feather="x-circle"></i></a> <a href="#" class="t_ic"><i data-feather="more-vertical"></i></a></td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
export default {
    name: 'login-Information',
    data() {
        return {

        }
    },
	
	created(){
	
		this.pageName('ACCOUNT LOGIN INFORMATION')
	}
}
</script>


// WEBPACK FOOTER //
// src/components/website/account/logininformation.vue